import { render, staticRenderFns } from "./EscolherCliente.vue?vue&type=template&id=35ca4a7d&"
import script from "./EscolherCliente.vue?vue&type=script&lang=js&"
export * from "./EscolherCliente.vue?vue&type=script&lang=js&"
import style0 from "./EscolherCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports